module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "aso-upload-card",
    class: {
      'aso-upload-card--disabled': _vm.disabled
    }
  }, [_c('p', {
    staticClass: "aso-upload-card__label"
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('div', {
    ref: "triggerRef",
    staticClass: "aso-upload-card__trigger"
  }, [_c('button', {
    staticClass: "aso-upload-card__visual",
    style: (_vm.visualStyle),
    attrs: {
      "type": "button",
      "disabled": _vm.disabled || _vm.busy
    },
    on: {
      "click": _vm.handlePrimaryAction
    }
  }, [(_vm.loading) ? _c('span', {
    staticClass: "aso-upload-card__loader"
  }, [_vm._v("Falta pouco...")]) : (_vm.uploaded) ? _c('span', {
    staticClass: "aso-upload-card__status"
  }, [_vm._v("Arquivo validado")]) : (_vm.hasError) ? _c('span', {
    staticClass: "aso-upload-card__status"
  }, [_vm._v("Falha no upload")]) : _c('span', {
    staticClass: "aso-upload-card__status"
  }, [_vm._v("Toque para selecionar")])]), _vm._v(" "), (_vm.showMobileOptions) ? _c('div', {
    staticClass: "aso-upload-card__tooltip"
  }, [_c('button', {
    staticClass: "aso-upload-card__tooltip-btn aso-upload-card__tooltip-btn--primary",
    attrs: {
      "type": "button",
      "disabled": _vm.disabled || _vm.busy
    },
    on: {
      "click": _vm.openCamera
    }
  }, [_vm._v("\n        Abrir camera\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "aso-upload-card__tooltip-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.disabled || _vm.busy
    },
    on: {
      "click": _vm.openGallery
    }
  }, [_vm._v("\n        Selecionar arquivo\n      ")])]) : _vm._e()]), _vm._v(" "), _c('input', {
    ref: "cameraInput",
    staticClass: "aso-upload-card__hidden-input",
    attrs: {
      "type": "file",
      "accept": "image/png,image/jpeg",
      "capture": "environment",
      "disabled": _vm.disabled || _vm.busy
    },
    on: {
      "change": _vm.onSelect
    }
  }), _vm._v(" "), _c('input', {
    ref: "galleryInput",
    staticClass: "aso-upload-card__hidden-input",
    attrs: {
      "type": "file",
      "accept": "image/png,image/jpeg",
      "disabled": _vm.disabled || _vm.busy
    },
    on: {
      "change": _vm.onSelect
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45bc2e84"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/funcionario/aso/assinar/UploadDocumentCard.vue
// module id = 1414
// module chunks = 45